import { } from '@/constants/products';
export const COVER_TYPES = [
  'income-protection-insurance', 'life-insurance', 'mortgage-protection-insurance', 'serious-illness-cover'
].map(type => {
  const parts = type.split('-').splice(0, 2);
  const path = `compare-${type}`;
  return {
    api: parts.join('_'),
    basePath: path,
    code: parts.map(part => part[0].toUpperCase()).join(''),
    path,
    scope: parts.join('-')
  };
});

export const EMPLOYMENT_STATUSES = [
  'employed',
  'household_duties',
  'retired',
  'self_employed',
  'unemployed'
];

export const EMPLOYMENT_STATUSES_CAR = [
  'employed',
  'household_duties',
  'retired',
  'self_employed',
  'unemployed',
  'student'
];

export const FORM_STEPS_CAR = ['your-car', 'about-you', 'driving-experience', 'additional-drivers', 'declarations'];

export const LIFE_INSURANCE_COVER_ATTRIBUTES = {
  min: 5000,
  max: 10000000,
  step: 1000,
  type: '€'
};
export const LIFE_INSURANCE_MAX_AGE = 79;
export const LIFE_INSURANCE_MAX_AGE_WITH_TERM = 90;
export const LIFE_INSURANCE_MAX_TERM = 40;

export const LIFE_INSURANCE_APPLICATION_PARAMS = [
  'affordability_agreed',
  'bml_broker_id',
  'invoice_ref',
  'life_insurance_plan_id',
  'mortgage_application_stage',
  'preferred_time',
  'privacy_policy_agreed',
  'tacs_agreed',
  'terms_conditions_agreed'
];

export const LIFE_INSURANCE_PLAN_FEATURES = [
  'terminal_illness',
  'cancer_cover',
  'childrens_life',
  'convertible',
  'funeral_cover',
  'free_waiver_of_premium',
  'indexation',
  'escalation',
  'specified_illness'
];

export const HI_ALARM_TYPE = [
  'no_alarm',
  'alarmed',
  'monitored'
];

export const HI_HEATING_TYPE = [
  { key: 'air_to_water', value: 'air_to_water' },
  { key: 'electric', value: 'electric' },
  { key: 'gas', value: 'gas' },
  { key: 'mixture_oil', value: 'mixture_oil' },
  { key: 'oil', value: 'oil' },
  { key: 'solar_wind', value: 'solar_wind' },
  { key: 'solid_fuel', value: 'solid_fuel' },
  { key: 'woodchip', value: 'woodchip' },
  { key: 'geothermal', value: 'geothermal' }
];

export const HI_ITEM_TYPES = [
  { key: 'jewellery', value: 'jewellery' },
  { key: 'laptop', value: 'laptop' },
  { key: 'phone', value: 'phone' },
  { key: 'bike', value: 'bike' },
  { key: 'sports', value: 'sports' },
  { key: 'music', value: 'music' },
  { key: 'camera', value: 'camera' },
  { key: 'hearing', value: 'hearing' }
];

export const HI_HOME_USE = [
  { key: 'main_home', value: 'main_home' },
  { key: 'rented', value: 'rented' },
  { key: 'investment_professionals', value: 'investment_professionals' },
  { key: 'investment_family', value: 'investment_family' }
];

export const HI_MONTHLY_CUTOFF = 200;

export const HI_PROPERTY_TYPE = [
  { key: 'ground_floor', value: 'ground_floor' },
  { key: 'above_ground', value: 'above_ground' },
  { key: 'bungalow', value: 'bungalow' },
  { key: 'detached', value: 'detached' },
  { key: 'dormer', value: 'dormer' },
  { key: 'end_terrace_bungalow', value: 'end_terrace_bungalow' },
  { key: 'end_terrace_house', value: 'end_terrace_house' },
  { key: 'mid_terrace_bungalow', value: 'mid_terrace_bungalow' },
  { key: 'semi', value: 'semi' },
  { key: 'terrace', value: 'terrace' },
  { key: 'multistorey', value: 'multistorey' },
  { key: 'maisonette', value: 'maisonette' }
];

export const HI_ROOF_FELT = [
  'less_20',
  'between_21_30',
  'more_30'
];

export const HI_ZURICH_PHONES = [
  '0818400700'
];

export const HI_STAGES = [
  { key: 'ftb', value: 'ftb' },
  { key: 'less_1', value: 'less_1' },
  { key: 'year_1', value: 'year_1' },
  { key: 'year_2', value: 'year_2' },
  { key: 'year_3', value: 'year_3' },
  { key: 'year_4', value: 'year_4' },
  { key: 'year_5', value: 'year_5' },
  { key: 'year_6', value: 'year_6' }
];

export const MARITAL_STATUSES = [
  'common_law_spouse',
  'divorced',
  'married',
  'separated',
  'single',
  'widowed'
];

export const MOTOR_MILEAGE = [
  { key: 'km_1', value: 1000 },
  { key: 'km_2', value: 2000 },
  { key: 'km_3', value: 3000 },
  { key: 'km_4', value: 4000 },
  { key: 'km_5', value: 5000 },
  { key: 'km_6', value: 6000 },
  { key: 'km_7', value: 7000 },
  { key: 'km_8', value: 8000 },
  { key: 'km_9', value: 9000 },
  { key: 'km_10', value: 10000 },
  { key: 'km_15', value: 15000 },
  { key: 'km_20', value: 20000 },
  { key: 'km_25', value: 25000 },
  { key: 'km_30', value: 30000 },
  { key: 'km_50', value: 50000 }
];

export const MOTOR_SECURITY_TYPE = [
  'no_security',
  'alarm',
  'immobiliser',
  'alarm_immobiliser',
  'alarm_tracker',
  'full_security'
];

export const MOTOR_USAGE = [
  'domestic',
  'commute',
  'business'
];

export const MOTOR_LICENCE_TYPE = [
  'full_irish',
  'learner_irish',
  'full_uk',
  'full_eu',
  'other'
];

export const MOTOR_LICENCE_YEARS_HELD = [
  'ly_less_1',
  'ly_year_1',
  'ly_year_2',
  'ly_year_3',
  'ly_year_4',
  'ly_year_5',
  'ly_year_6',
  'ly_year_7',
  'ly_year_8',
  'ly_year_9',
  'ly_more_10'
];

export const MOTOR_CLAIMS_TOTAL = [
  'no_claims',
  'claim_1',
  'claim_2',
  'claim_3',
  'claim_4',
  'more_5_claims'
];

export const MOTOR_NO_CLAIMS_YEARS = [
  'ncd_not_insured',
  'ncd_less_1',
  'ncd_year_1',
  'ncd_year_2',
  'ncd_year_3',
  'ncd_year_4',
  'ncd_year_5',
  'ncd_year_6',
  'ncd_year_7',
  'ncd_year_8',
  'ncd_year_9',
  'ncd_more_10'
];

export const MOTOR_NAMED_DRIVER_CLAIM_FREE_YEARS = [
  'cf_less_1',
  'cf_year_1',
  'cf_year_2',
  'cf_year_3',
  'cf_year_4',
  'cf_year_5',
  'cf_year_6',
  'cf_year_7',
  'cf_year_8',
  'cf_year_9',
  'cf_more_10'
];

export const MOTOR_PENALTY_POINTS = [
  'no_points',
  'points_1',
  'points_2',
  'points_3',
  'points_4',
  'points_5',
  'points_6',
  'points_7',
  'points_8',
  'points_9',
  'points_10',
  'points_11',
  'points_12'
];

export const MOTOR_WINDSCREEN_CLAIMS = [
  'no_wclaims',
  'wclaim_1',
  'wclaim_2',
  'wclaim_3',
  'more_4_wclaims'
];

export const MORTGAGE_STAGES = [
  'approval_in_principal',
  'approved',
  'sale_agreed',
  'drawdown'
];

export const PROTECTION_DETAIL_ATTRS = [
  'employment_business_id',
  'employment_status_id',
  'occupation_id'
];

export const RELATIONSHIP_TYPE = [
  'your_parent',
  'partner_spouse_car',
  'partner_spouse',
  'daughter',
  'son',
  'other'
];

export const SERIOUS_ILLNESS_MAX_AGE = 64;
